// extracted by mini-css-extract-plugin
export default {"buttonCard":"buttonCard_buttonCard__p8TYU"};